export const BACK_BUTTON_HEIGHT_PX = '48px';
